// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"274":"OrganizationDetails","527":"Site","701":"AOI"}[chunkId] || chunkId) + "." + {"57":"c0a5ce9e","274":"1c3d5894","527":"740d4b62","701":"d0f5f427"}[chunkId] + ".chunk.css";
};